import Utils from "framework7/utils/utils";
import $ from "dom7";

export default  {
  methods: {
    locationFound(instance, mapObject, e, extraParams) {

      if (typeof extraParams === 'undefined') {
        extraParams = instance.extraParams;
      }

      // vymazeme predchadzajuce
      this.locationClearMarker(instance, mapObject, extraParams);

      let radius = e.accuracy;
      extraParams.circleMarkerObject = L.circle(e.latlng, radius).addTo(mapObject);

      let markerIcon = L.icon({
        iconUrl: './static/shmu/img/marker-icon.png',
        iconSize:     [25, 37], // size of the icon
        iconAnchor:   [13, 37], // point of the icon which will correspond to marker's location
      });

      extraParams.pointMarkerObject = L.marker(e.latlng, { icon: markerIcon }).addTo(mapObject);
      extraParams.clearBtnVar = true;

    },
    locationError(instance, e) {
      instance.$f7.dialog.alert('Nepodarilo získať aktuálnu polohu: ' + e.message, 'Nastala chyba');
    },
    locationClearMarker(instance, mapObject, extraParams) {

      if (typeof extraParams === 'undefined') {
        extraParams = instance.extraParams;
      }

      if (extraParams.circleMarkerObject !== null) {
        mapObject.removeLayer(extraParams.circleMarkerObject);
        extraParams.circleMarkerObject = null;
      }
      if (extraParams.pointMarkerObject !== null) {
        mapObject.removeLayer(extraParams.pointMarkerObject);
        extraParams.pointMarkerObject = null;
      }

      extraParams.clearBtnVar = false;

    },
    locationLocate(instance, mapObject, zoom) {
      mapObject.locate({setView: true, maxZoom: zoom});
    },
    locationMapInitEvents(instance, mapObject, onFoundMethod, onErrorMethod) {
      if (onFoundMethod) {
        mapObject.on('locationfound', onFoundMethod);
      } else {
        mapObject.on('locationfound', instance.onLocationFound);
      }

      if (onErrorMethod) {
        mapObject.on('locationerror', onErrorMethod);
      } else {
        mapObject.on('locationerror', instance.onLocationError);
      }
    },

    isHTTPS() {
      if (location.protocol !== 'https:') {
        return false;
      }
      return true;
    },

    calculateDistance(lat1, lon1, lat2, lon2, unit) {
      var radlat1 = Math.PI * lat1/180
      var radlat2 = Math.PI * lat2/180
      var radlon1 = Math.PI * lon1/180
      var radlon2 = Math.PI * lon2/180
      var theta = lon1-lon2
      var radtheta = Math.PI * theta/180
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist)
      dist = dist * 180/Math.PI
      dist = dist * 60 * 1.1515
      if (unit==="K") { dist = dist * 1.609344 }
      if (unit==="N") { dist = dist * 0.8684 }
      return dist
    },

    getGeoLocation(successCallback, ErrorCallback, options) {
      if (typeof options  === 'undefined') {
         let options = {
           enableHighAccuracy: true,
           timeout: 5000,
           maximumAge: 0
         }
      }

      navigator.geolocation.getCurrentPosition(successCallback, ErrorCallback, options);
    }


  },
  computed: {
    isGeolocationEnabled() {
      return (location.hostname === "localhost" || location.hostname === "127.0.0.1" || this.isHTTPS());
    },
  }
}
